import React, { useEffect, useState, useRef } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Box,
  FormControlLabel,
  Checkbox,
  RadioGroup,
  Radio,
  TextField,
  Select,
  MenuItem,
  Autocomplete,
} from "@mui/material";
import {
  ExpandMore,
  PlayArrow,
  PictureAsPdf,
  TableChart,
} from "@material-ui/icons";
import GridItem from "components/Grid/GridItem";
import GridContainer from "components/Grid/GridContainer";
import Button from "components/CustomButtons/CustomButton";
import Daily from "./ReportsView/Daily";
import Statement from "./ReportsView/Statement";
import Recap from "./ReportsView/Recap";
import Premium from "./ReportsView/Premium";
import Method from "./ReportsView/Method";
import Comparison from "./ReportsView/Comparison";
import PolicyInfo from "./ReportsView/PolicyInfo";
import ExpirationList from "./ReportsView/ExpirationList";
import CancelEndorsements from "./ReportsView/CancelEndorsement";
import AgencyFee from "./ReportsView/AgencyFee";
import Charge from "./ReportsView/Charge";
import VehicleType from "./ReportsView/VehicleType";
import AgentList from "./ReportsView/AgentList";
import Analysis from "./ReportsView/Analysis";
import CustomerSales from "./ReportsView/CustomerSales";
import {
  getReportData,
  getCatalogsReports,
} from "views/Services/ReportService";

import { makeStyles } from "@material-ui/core/styles";
import CustomSelect from "components/CustomSelect/CustomSelect";
import CustomInput from "components/CustomInput/CustomOutlinedInput";

import { useTranslation } from "react-i18next";

import styles from "assets/jss/material-dashboard-pro-react/views/loginPageStyle.js";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import dayjs from "dayjs";
import Card from "components/Card/Card";
import CardHeader from "components/Card/CardHeader";
import Coverage from "./ReportsView/Coverage";

import { isAgent } from "components/Utils/utils.js";

const useStyles = makeStyles(styles);

const currentYear = new Date().getFullYear().toString();

export default function ReportsPanel() {
  const classes = useStyles();
  const { t } = useTranslation();
  const [info, setInfo] = React.useState([]);
  const [agency, setAgency] = React.useState(null);
  const [timezone, setTimezone] = React.useState(null);
  const [year, setYear] = React.useState(null);
  const [month, setMonth] = React.useState(null);
  const [range, setRange] = React.useState(null);
  const [start, setStart] = React.useState(dayjs());
  const [end, setEnd] = React.useState(dayjs());
  const [commissions, setCommissions] = React.useState(null);
  const [catalogs, setCatalogs] = React.useState([]);
  const [viewType, setViewType] = React.useState("");
  const [separatedAgency, setSeparatedAgency] = React.useState(false);
  const [bluefire, setBluefire] = React.useState(false);
  const [defaultTimezone, setDefaultTimezone] = React.useState(null);
  const [viewReport, setViewReport] = React.useState("dashboard");
  const dispatch = useDispatch();
  const history = useHistory();

  const [years, setYears] = React.useState([]);

  const formatNumber = (num) => {
    num = parseFloat(num) || 0;
    return num.toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  useEffect(() => {
    const yearsArray = [];
    for (let i = new Date().getFullYear(); i >= 2000; i--) {
      yearsArray.push({ value: i.toString(), label: i.toString() });
    }
    setYears(yearsArray);
    setYear(currentYear);
    setMonth("01");
    if (!isAgent) {
      window.location.href = "/admin/home";
    }
  }, []);

  const reportOptionsList = {
    term1: {
      month1: "",
      year1: "",
      term1_agency: "",
      term1_timezone: "",
      range1: "",
      report: "daily",
    },
    term2: {
      month2: "",
      year2: "",
      term2_agency: "",
      term2_timezone: "",
      range2: "",
      report: "statement",
    },
    term3: {
      month3: "",
      year3: "",
      term3_agency: "",
      term3_commissions: "",
      term3_timezone: "",
      range3: "",
      report: "recap",
    },
    term4: {
      month4: "",
      year4: "",
      term4_agency: "",
      term4_timezone: "",
      range4: "",
      report: "prem",
    },
    term5: {
      month5: "",
      year5: "",
      term5_agency: "",
      term5_timezone: "",
      range5: "",
      report: "meth",
    },
    term6: {
      month6: "",
      year6: "",
      term6_agency: "",
      term6_timezone: "",
      range6: "",
      report: "comp",
    },
    term7: {
      month7: "",
      year7: "",
      term7_agency: "",
      term7_timezone: "",
      range7: "",
      report: "pol",
    },
    term8: {
      month8: "",
      year8: "",
      term8_agency: "",
      term8_timezone: "",
      range8: "",
      report: "exp",
    },
    term9: {
      month9: "",
      year9: "",
      term9_agency: "",
      term9_timezone: "",
      range9: "",
      report: "endorsement",
    },
    term10: {
      month10: "",
      year10: "",
      term10_agency: "",
      term10_timezone: "",
      range10: "",
      report: "agent",
    },
    term11: {},
    term12: {
      term12: "term12_1",
      month12: "",
      year12: "",
      term12_agency: "",
      term12_timezone: "",
      range12: "",
      report: "charge",
    },
    term13: {
      month13: "",
      year13: "",
      term13_agency: "",
      term13_timezone: "",
      range13: "",
      report: "vehtype",
    },
    term14: {
      term14_agency: "",
      report: "agentslist",
    },
    term15: {
      month15: "",
      year15: "",
      term15_agency: "",
      term15_timezone: "",
      range15: "",
      report: "coverage",
    },
    term16: {},
    term17: {
      month17: "",
      year17: "",
      term17_agency: "",
      term17_timezone: "",
      range17: "",
      report: "analysis",
    },
    term18: {
      month18: "",
      year18: "",
      term18_agency: "",
      term18_timezone: "",
      range18: "",
      report: "customersales",
    },
  };

  const toggleCheckbox = (name) => {
    switch (name) {
      case "separatedAgency":
        setSeparatedAgency(!separatedAgency);
        break;
      case "bluefire":
        setBluefire(!bluefire);
        break;
      default:
        break;
    }
  };

  const toggleSubAgentCommissions = () => {
    setCommissions(!commissions);
  };

  const onBack = () => {
    setViewReport("dashboard");
    setInfo([]);
    setAgency(null);
    setTimezone(null);
    setYear(currentYear);
    setMonth("01");
    setTimezone("cst");
    setRange(null);
    setStart(dayjs());
    setEnd(dayjs());
    setCommissions(true);
    setViewType("");
    setSeparatedAgency(false);
  };

  useEffect(() => {
    getCatalogs();
  }, [dispatch]);

  const getAgencyIdFromCatalog = (producer_code, agencies) => {
    const agency = agencies.find(
      (agency) => agency.producer_code === producer_code
    );
    return agency ? agency.id : null;
  };

  const getReport = async (reportId, type) => {
    let data = reportOptionsList["term" + reportId];
    data["month" + reportId] = month;
    data["year" + reportId] = year;
    data["term" + reportId + "_agency"] = agency;
    data["term" + reportId + "_timezone"] = timezone;
    if (viewType === "2") {
      data["range" + reportId] =
        start.format("MM/DD/YYYY hh:mmA") +
        " - " +
        end.format("MM/DD/YYYY hh:mmA");
    }
    data["term" + reportId] = "term" + reportId + "_" + viewType;
    if (reportId === 3 && commissions) {
      data["term" + reportId + "_commissions"] = true;
    }
    if (separatedAgency) {
      data["separated" + reportId] = "separate";
    }
    if (bluefire) {
      data["bluefire"] = true;
    }
    if (typeof type !== "undefined") {
      data["type"] = type;
    }
    if (agency != null || localStorage.getItem("userType") === "2") {
      data["agent_selected"] =
        localStorage.getItem("userType") === "2"
          ? getAgencyIdFromCatalog(
              localStorage.getItem("producerCode"),
              catalogs.agencies
            )
          : agency;
    }

    const resultSubmit = await dispatch(getReportData(data));
    if (typeof type !== "undefined") {
      const link = document.createElement("a");
      link.href =
        "data:application/" +
        type +
        ";base64," +
        resultSubmit.payload.data.file;
      link.download = resultSubmit.payload.data.name;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      return;
    } else {
      let info = resultSubmit.payload.data.infos
        ? resultSubmit.payload.data.infos
        : resultSubmit.payload.data.info;
      if (reportId === 17) {
        info = {
          total: resultSubmit.payload.data.total,
          totalb: resultSubmit.payload.data.totalb,
        };
      }
      setInfo(info || []);
      setDefaultTimezone(resultSubmit.payload.data.timezone);
      setViewReport(data.report);
    }
  };

  const [openIndex, setOpenIndex] = useState(null);

  const changeAccordion = (index) => {
    if (openIndex === index) {
      setOpenIndex(null);
    } else {
      onBack();
      setOpenIndex(index);
    }
  };

  const getCatalogs = async () => {
    const resultSubmit = await dispatch(getCatalogsReports({}));
    setCatalogs(resultSubmit.payload.data);
    setTimezone("cst");
  };

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    switch (name) {
      case "agency":
        setAgency(value);
        break;
      case "timezones":
        setTimezone(value);
        break;
      case "years":
        setYear(value);
        break;
      case "months":
        setMonth(value);
        break;
      case "range":
        setRange(value);
        break;
      case "commissions":
        setCommissions(value);
        break;
      default:
        break;
    }
  };

  const reportsList = {
    daily: (
      <Daily
        infos={info}
        title={bluefire ? "Daily Bluefire Report" : "Daily Report"}
        timezones={catalogs.timezones}
        report_tz={defaultTimezone}
        onGenerateCsv={getReport}
        onGeneratePdf={getReport}
        onBack={onBack}
        bluefire={bluefire}
        separatedAgency={separatedAgency}
        formatNumber={formatNumber}
      />
    ),
    statement: (
      <Statement
        infos={info}
        title="Statement of Account"
        timezones={catalogs.timezones}
        report_tz={defaultTimezone}
        onGenerateCsv={getReport}
        onGeneratePdf={getReport}
        onBack={onBack}
        formatNumber={formatNumber}
      />
    ),
    recap: (
      <Recap
        info={info}
        title="Recap of Sub-Agent Sales"
        timezones={catalogs.timezones}
        report_tz={defaultTimezone}
        onGenerateCsv={getReport}
        onGeneratePdf={getReport}
        onBack={onBack}
        separatedAgency={separatedAgency}
        formatNumber={formatNumber}
      />
    ),
    prem: (
      <Premium
        infos={info}
        title="Premium Analysis"
        timezones={catalogs.timezones}
        report_tz={defaultTimezone}
        onGenerateCsv={getReport}
        onGeneratePdf={getReport}
        onBack={onBack}
        separatedAgency={separatedAgency}
        formatNumber={formatNumber}
      />
    ),
    meth: (
      <Method
        infos={info}
        title="Method of Payment Report"
        timezones={catalogs.timezones}
        report_tz={defaultTimezone}
        onGenerateCsv={getReport}
        onGeneratePdf={getReport}
        onBack={onBack}
        separatedAgency={separatedAgency}
        formatNumber={formatNumber}
      />
    ),
    comp: (
      <Comparison
        info={info}
        title="Comparison Report"
        timezones={catalogs.timezones}
        report_tz={defaultTimezone}
        onGenerateCsv={getReport}
        onGeneratePdf={getReport}
        onBack={onBack}
        separatedAgency={separatedAgency}
        formatNumber={formatNumber}
      />
    ),
    pol: (
      <PolicyInfo
        infos={info}
        title="Policy Info"
        timezones={catalogs.timezones}
        report_tz={defaultTimezone}
        onGenerateCsv={getReport}
        onGeneratePdf={getReport}
        onBack={onBack}
        separatedAgency={separatedAgency}
        formatNumber={formatNumber}
      />
    ),
    exp: (
      <ExpirationList
        infos={info}
        title="Expiration List Report"
        timezones={catalogs.timezones}
        report_tz={defaultTimezone}
        onGenerateCsv={getReport}
        onGeneratePdf={getReport}
        onBack={onBack}
        separatedAgency={separatedAgency}
        formatNumber={formatNumber}
      />
    ),
    endorsement: (
      <CancelEndorsements
        infos={info}
        title="Cancellations/Endorsements Report"
        timezones={catalogs.timezones}
        report_tz={defaultTimezone}
        onGenerateCsv={getReport}
        onGeneratePdf={getReport}
        onBack={onBack}
        separatedAgency={separatedAgency}
        formatNumber={formatNumber}
      />
    ),
    agent: (
      <AgencyFee
        infos={info}
        title="Agent Fee Report"
        timezones={catalogs.timezones}
        report_tz={defaultTimezone}
        onGenerateCsv={getReport}
        onGeneratePdf={getReport}
        onBack={onBack}
        separatedAgency={separatedAgency}
        formatNumber={formatNumber}
      />
    ),
    charge: (
      <Charge
        info={info}
        title="Credit Card Charge Report"
        timezones={catalogs.timezones}
        report_tz={defaultTimezone}
        onGenerateCsv={getReport}
        onGeneratePdf={getReport}
        onBack={onBack}
        separatedAgency={separatedAgency}
        formatNumber={formatNumber}
      />
    ),
    vehtype: (
      <VehicleType
        info={info}
        title="Report by Vehicle Type"
        timezones={catalogs.timezones}
        report_tz={defaultTimezone}
        onGenerateCsv={getReport}
        onGeneratePdf={getReport}
        onBack={onBack}
        separatedAgency={separatedAgency}
        formatNumber={formatNumber}
      />
    ),
    agentslist: (
      <AgentList
        info={info}
        title="Agents List Report"
        timezones={catalogs.timezones}
        report_tz={defaultTimezone}
        onGenerateCsv={getReport}
        onGeneratePdf={getReport}
        onBack={onBack}
        separatedAgency={separatedAgency}
        formatNumber={formatNumber}
      />
    ),
    coverage: (
      <Coverage
        info={info}
        title="Coverage Analysis Report"
        timezones={catalogs.timezones}
        report_tz={defaultTimezone}
        onGenerateCsv={getReport}
        onGeneratePdf={getReport}
        onBack={onBack}
        separatedAgency={separatedAgency}
        formatNumber={formatNumber}
      />
    ),
    analysis: (
      <Analysis
        info={info}
        title="Analysis Report"
        timezones={catalogs.timezones}
        report_tz={defaultTimezone}
        onGenerateCsv={getReport}
        onGeneratePdf={getReport}
        onBack={onBack}
        separatedAgency={separatedAgency}
        formatNumber={formatNumber}
      />
    ),
    customersales: (
      <CustomerSales
        infos={info}
        title="Customer Sales Report"
        timezones={catalogs.timezones}
        report_tz={defaultTimezone}
        onGenerateCsv={getReport}
        onGeneratePdf={getReport}
        onBack={onBack}
        separatedAgency={separatedAgency}
        formatNumber={formatNumber}
      />
    ),
  };

  return (
    <div className={classes.container}>
      <GridContainer justify="center">
        <GridItem xs={12} sm={12} md={12}>
          <GridContainer
            style={{ padding: "20px 0px 40px 0px" }}
            justify="center"
          >
            <GridContainer>
              <GridItem xs={12} md={12}>
                <GridItem xs={12} sm={12} md={12} lg={12}>
                  <Card>
                    <CardHeader>
                      {viewReport === "dashboard" && (
                        <GridItem xs={12} sm={12} md={12}>
                          {/* Collapsible sections */}
                          {[
                            "Daily Report",
                            "Statement of Account",
                            "Recap of Sub-Agent Sales",
                            "Premium Analysis",
                            "Method of Payment Report",
                            "Comparison Report",
                            "Policy Info",
                            "Expiration List Report",
                            "Cancellations/Endorsements Report",
                            "Agency Fee Report",
                            "",
                            "Credit Card Charge Report",
                            "Report by Vehicle Type",
                            "Agents List Report",
                            "Coverage Analysis Report",
                            "",
                            "Premium Analysis Comparison",
                            "Customer Site Sales",
                          ].map((title, rowIndex) =>
                            title.trim() === "" ? null : (
                              <Accordion
                                key={rowIndex}
                                expanded={openIndex === rowIndex}
                                onChange={() => changeAccordion(rowIndex)}
                              >
                                <AccordionSummary expandIcon={<ExpandMore />}>
                                  <Typography fontWeight="bold">
                                    {title}
                                  </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                  <GridContainer>
                                    {title !== "Agents List Report" && (
                                      <GridItem xs={12} sm={12} md={3}>
                                        <RadioGroup>
                                          <FormControlLabel
                                            name="term1"
                                            value="month"
                                            checked={viewType === "1"}
                                            onChange={(e) => setViewType("1")}
                                            control={
                                              <Radio
                                                style={{ color: "#008670" }}
                                              />
                                            }
                                            label="Single Month Report"
                                          />
                                          <FormControlLabel
                                            name="term1"
                                            value="range"
                                            checked={viewType === "2"}
                                            onChange={(e) => setViewType("2")}
                                            control={
                                              <Radio
                                                style={{ color: "#008670" }}
                                              />
                                            }
                                            label="Date to Date Report"
                                          />
                                          {title === "Daily Report" && (
                                            <>
                                              <FormControlLabel
                                                name="separatedAgency"
                                                checked={separatedAgency}
                                                onChange={() =>
                                                  toggleCheckbox(
                                                    "separatedAgency"
                                                  )
                                                }
                                                control={
                                                  <Checkbox
                                                    style={{ color: "#008670" }}
                                                  />
                                                }
                                                label="Separate by Agency"
                                              />
                                              <FormControlLabel
                                                name="bluefire"
                                                checked={bluefire}
                                                onChange={() =>
                                                  toggleCheckbox("bluefire")
                                                }
                                                control={
                                                  <Checkbox
                                                    style={{ color: "#008670" }}
                                                  />
                                                }
                                                label="Bluefire Policies"
                                              />
                                            </>
                                          )}
                                        </RadioGroup>
                                      </GridItem>
                                    )}
                                    <GridItem xs={12} sm={12} md={9}>
                                      <GridContainer>
                                        {viewType === "1" &&
                                          title !== "Agents List Report" && (
                                            <>
                                              <GridItem xs={12} sm={12} md={3}>
                                                <CustomSelect
                                                  labelText={t("Month")}
                                                  helperText={null}
                                                  menuItems={
                                                    catalogs?.months
                                                      ? Object.entries(
                                                          catalogs.months
                                                        )
                                                          .sort(
                                                            ([a], [b]) =>
                                                              Number(a) -
                                                              Number(b)
                                                          )
                                                          .map(
                                                            ([
                                                              value,
                                                              label,
                                                            ]) => ({
                                                              value,
                                                              label,
                                                            })
                                                          )
                                                      : []
                                                  }
                                                  formControlProps={{
                                                    fullWidth: true,
                                                    className:
                                                      classes.customFormControlClasses,
                                                  }}
                                                  name="months"
                                                  onChange={(e) =>
                                                    handleFormChange(e)
                                                  }
                                                  inputProps={{
                                                    name: "months",
                                                    id: "months",
                                                    required: true,
                                                    value: month,
                                                    onChange: handleFormChange,
                                                  }}
                                                />
                                              </GridItem>
                                              <GridItem xs={12} sm={12} md={3}>
                                                <CustomSelect
                                                  labelText={t("Year")}
                                                  helperText={null}
                                                  menuItems={years}
                                                  formControlProps={{
                                                    fullWidth: true,
                                                    className:
                                                      classes.customFormControlClasses,
                                                  }}
                                                  name="years"
                                                  onChange={(e) =>
                                                    handleFormChange(e)
                                                  }
                                                  inputProps={{
                                                    name: "years",
                                                    id: "years",
                                                    required: true,
                                                    value: year,
                                                    onChange: handleFormChange,
                                                  }}
                                                />
                                              </GridItem>
                                            </>
                                          )}
                                        {viewType === "2" &&
                                          title !== "Agents List Report" && (
                                            <GridItem xs={12} sm={12} md={6}>
                                              <LocalizationProvider
                                                dateAdapter={AdapterDayjs}
                                              >
                                                <GridContainer spacing={2}>
                                                  <GridItem xs={12} sm={6}>
                                                    <DateTimePicker
                                                      label="Start Date"
                                                      value={start}
                                                      onChange={(newValue) =>
                                                        setStart(newValue)
                                                      }
                                                      slots={{
                                                        textField: CustomInput,
                                                      }}
                                                      slotProps={{
                                                        textField: {
                                                          labelText:
                                                            "Start Date",
                                                          id: "startDate",
                                                          value: start,
                                                          formControlProps: {
                                                            fullWidth: true,
                                                          },
                                                        },
                                                      }}
                                                    />
                                                  </GridItem>

                                                  <GridItem xs={12} sm={6}>
                                                    <DateTimePicker
                                                      label="End Date"
                                                      value={end}
                                                      onChange={(newValue) =>
                                                        setEnd(newValue)
                                                      }
                                                      slots={{
                                                        textField: CustomInput,
                                                      }}
                                                      slotProps={{
                                                        textField: {
                                                          labelText: "End Date",
                                                          id: "endDate",
                                                          value: end,
                                                          formControlProps: {
                                                            fullWidth: true,
                                                          },
                                                        },
                                                      }}
                                                    />
                                                  </GridItem>
                                                </GridContainer>
                                              </LocalizationProvider>
                                            </GridItem>
                                          )}
                                        {localStorage.getItem("userType") ===
                                          "1" && (
                                          <GridItem xs={12} sm={12} md={3}>
                                            <Autocomplete
                                              options={catalogs?.agencies || []}
                                              getOptionLabel={(option) =>
                                                option.producer_code +
                                                " - " +
                                                option.agency_name
                                              }
                                              onChange={(event, value) => {
                                                if (value) {
                                                  setAgency(value.id);
                                                } else {
                                                  setAgency(null);
                                                }
                                              }}
                                              renderInput={(params) => (
                                                <CustomInput
                                                  inputProps={params.inputProps}
                                                  InputProps={params.InputProps}
                                                  labelText="Agency"
                                                  id="agency"
                                                  formControlProps={{
                                                    fullWidth: true,
                                                    className:
                                                      classes.customFormControlClasses,
                                                  }}
                                                />
                                              )}
                                            />
                                          </GridItem>
                                        )}
                                        {title !== "Agents List Report" && (
                                          <GridItem xs={12} sm={12} md={3}>
                                            <CustomSelect
                                              labelText={t("Timezone")}
                                              helperText={null}
                                              menuItems={
                                                catalogs?.timezones
                                                  ? Object.entries(
                                                      catalogs.timezones
                                                    ).map(([value, label]) => ({
                                                      value,
                                                      label,
                                                    }))
                                                  : []
                                              }
                                              formControlProps={{
                                                fullWidth: true,
                                                className:
                                                  classes.customFormControlClasses,
                                              }}
                                              name="timezones"
                                              onChange={(e) =>
                                                handleFormChange(e)
                                              }
                                              inputProps={{
                                                name: "timezones",
                                                id: "timezones",
                                                required: true,
                                                value: timezone,
                                                onChange: handleFormChange,
                                              }}
                                            />
                                          </GridItem>
                                        )}
                                        {title ===
                                          "Recap of Sub-Agent Sales" && (
                                          <FormControlLabel
                                            label="Subagent Commissions"
                                            control={
                                              <Checkbox
                                                checked={commissions}
                                                onChange={
                                                  toggleSubAgentCommissions
                                                }
                                                name="subAgentCommissions"
                                                style={{ color: "#008670" }}
                                              />
                                            }
                                          />
                                        )}
                                      </GridContainer>
                                    </GridItem>
                                  </GridContainer>

                                  <GridContainer>
                                    {title !== "Agents List Report" && (
                                      <>
                                        <GridItem xs={12} sm={12} md={2}>
                                          <Button
                                            id="sendEmail"
                                            type="submit"
                                            variant="green"
                                            onClick={() => {
                                              getReport(rowIndex + 1);
                                            }}
                                            block
                                          >
                                            <PlayArrow />
                                            Run Report
                                          </Button>
                                        </GridItem>
                                        <GridItem xs={12} sm={12} md={2}>
                                          <Button
                                            id="sendEmail"
                                            type="submit"
                                            variant="green"
                                            onClick={() => {
                                              getReport(rowIndex + 1, "pdf");
                                            }}
                                            block
                                          >
                                            <PictureAsPdf />
                                            PDF
                                          </Button>
                                        </GridItem>
                                      </>
                                    )}
                                    <GridItem xs={12} sm={12} md={2}>
                                      <Button
                                        id="sendEmail"
                                        type="submit"
                                        variant="green"
                                        onClick={() => {
                                          getReport(rowIndex + 1, "csv");
                                        }}
                                        block
                                      >
                                        <TableChart />
                                        CSV
                                      </Button>
                                    </GridItem>
                                  </GridContainer>
                                </AccordionDetails>
                              </Accordion>
                            )
                          )}
                        </GridItem>
                      )}
                      {viewReport !== "dashboard" && (
                        <GridItem xs={12} sm={12} md={12}>
                          {reportsList[viewReport]}
                        </GridItem>
                      )}
                    </CardHeader>
                  </Card>
                </GridItem>
              </GridItem>
            </GridContainer>
          </GridContainer>
        </GridItem>
      </GridContainer>
    </div>
  );
}
